import HomeComponent from './Home';

import { appConfig } from '../../config/appConfig';

export const paths = {
  home: {
    to: '/',
    title: appConfig.home.tabTitle,
  },
};

export default [
  {
    title: paths.home.title,
    path: paths.home.to,
    exact: true,
    component: HomeComponent,
  },
];
